import { I18nLang } from '@pharmsnap/shared/i18n'

export const REVERSE_LANGUAGE_MAP: Record<I18nLang, 'zh_CN' | 'en_US' | 'ja_JP'> = {
  cn: 'zh_CN',
  en: 'en_US',
  jp: 'ja_JP',
}

export const TermsOfServiceHrefByCN = 'https://www.zhihuiya.com/legal/terms'
export const TermsOfServiceHrefByUS = 'https://www.patsnap.com/legal/'
